module.exports = __webpack_public_path__ + "img/sidebnb.b2d5d544.jpg";